const Backbone = window.Backbone;
const text = window.text;
const url = window.url;
const acceptableTypes = ['ebook', 'audiobook', 'video', 'magazine'];

import {Modal} from '../common/modal';
import TitleFormatBadge from '../media/views/TitleInfo/TitleFormatBadge';
import Cover from '../media/Cover';
import KindlePreference from '../kindle_preference_modal/KindlePreference';
import DownloadWarningModal from '../media/views/DownloadWarningModal';
import KindleTroubleModal from '../kindle_trouble_modal/views/KindleTroubleModal';

export default class TitleFulfillmentModal extends Backbone.View {
    constructor({loan, title, bus, featureManager, patronSettings, accountLimits, isRenewal = false, formatLock = null}) {
        super(...arguments);
        this.loan = loan;
        this.title = title;
        this.bus = bus;
        this.featureManager = featureManager;
        this.patronSettings = patronSettings;
        this.accountLimits = accountLimits;
        this.isRenewal = isRenewal;
        this.formatLock = formatLock;
        this._views = [];

        this._views.push(this.cover = new Cover({ model: this.title, coverWidths: { mobile: 250, tablet: 250, desktop: 250 }}));
        this._views.push(this.formatBadge = new TitleFormatBadge({ typeId: this.title.get('type').id }));
    }


    render() {
        if (acceptableTypes.includes(this.loan.type.id)){
            this.formatBadge.render();

            let html = this.renderTemplate();

            let modalContents = {
                title: text('genericSuccess'),
                autoShow: false,
                classes: ['large', 'TitleFulfillmentModal'],
                content: html
            };

            this.modal = new Modal(modalContents);

            this.attachEvents(this.modal.$el);
            this.modal.show();
        } else {
            window.Logger.log('error', 'Title has unexpected media type', {
                source : 'fulfillment modal',
                title : this.loan.title,
                id : this.loan.id,
                type : this.loan.type
            });
            toaster.push(text('genericError'), 'error');
        }
    }

    attachEvents(node){
        let titleModel = this.title;
        node.find('.kindleFulfillmentButton').click((evt) => {

            let formatId = $(evt.currentTarget).attr('data-format-id');

            if (this.featureManager.isEnabled('kindleLoanOffer') &&
                !(Cookies.get('kindleFulfillmentAppOverride') && Cookies.get('kindleFulfillmentAppOverride') === '1') &&
                window.globalPreferences.get('kindleFulfillment') == null) {
                // don't follow the href on the kindle button since we need to show a modal sequence first.
                evt.preventDefault();

                let fulfillTarget = url(window.routes.mediaDownload, { format: formatId, mediaId: this.loan.id });

                (new KindlePreference({
                    bus: this.bus,
                    globalPreferences: window.globalPreferences,
                    source: 'content_fulfillment',
                    completionTargetUrl: fulfillTarget
                })).run();
            }
            this.bus.trigger('title:download', {titleModel, context: {formatId}});
        });

        node.find('.od-format-button').click((evt) => {
            let formatId = $(evt.currentTarget).attr('data-format-id');
            this.bus.trigger('title:download', {titleModel, context: {formatId}});
        });

        node.find('.loan-button-nonkindle, .Loans-bundledButton').click((evt) => {
            new DownloadWarningModal($(evt.currentTarget));
            let formatId = $(evt.currentTarget).attr('data-format-id');
            this.bus.trigger('title:download', {titleModel, context: {formatId}});
        });

        node.find('.kindle-report-trouble-button').on('click', (event) => {
            const titleId = this.loan.id;
            const alternativeFormat = this.loan.alternativeToKindle;
            const modal = new KindleTroubleModal({ titleId, alternativeFormat });
        });
    }

    get suppressAudiobookButton(){
        const device = detectshun.browser();
        const isMac = !!(window.navigator.userAgent.match(/Mac/) && !device.ios);
        return this.loan.isAudiobook
            && this.featureManager.isEnabled('noAudiobooksForMacOS')
            && isMac
            && !device.ios
            && (!this.featureManager.isEnabled('reenableMp3DownloadMacOSPreCatalina') || !window.OverDrive.isPreCatalinaMac);
    }

    get isAudiobookOnMac(){
        const device = detectshun.browser();
        const isMac = !!(window.navigator.userAgent.match(/Mac/) && !device.ios);
        return this.loan.isAudiobook && this.featureManager.isEnabled('noAudiobooksForMacOS') && isMac && !device.ios;
    }

    renderTemplate()
    {
        this.filterRestrictedFormats();
        let firstButton = this.getFirstButton();

        let kindleOnly = (this.isRenewal && this.formatLock === 'ebook-kindle');

        let buttonStack =
            `${firstButton}
                ${ !this.suppressAudiobookButton && this.loan.showDivider && !kindleOnly ? this.renderButtonDivider() : ''}
                ${this.loan.showODFormatButton && !kindleOnly ? this.renderODReadButton() : ''}
                ${this.loan.showNonKindleButtonBelowDivider
                    ? this.renderDownloadButton()
                    : this.loan.showDownloadDropdown
                        ? this.renderDownloadDropdown()
                        : '' }
                ${this.loan.restrictedFormats.length > 0 && !this.loan.hasNonKindleNonReadFormat && !this.loan.preferKindle ? this.renderRestrictedFormatWarning(this.loan.restrictedFormats) : ''}
                ${this.loan.isEbook && !this.loan.showKindleTroubleAccordian && this.loan.hasKindleFormat ? `<div class="kindle-trouble-container">${this.renderKindleReportLink()}</div>` : ''}
                `;
        if (window.featureManager.isEnabled('macOSAudiobookMessaging') && this.isAudiobookOnMac){
            buttonStack = `${buttonStack}
            <div class="macOsAudiobookWarning">
                <div class="supportedVersions">${html("macOsAudiobookSupression.supoortedVersions")}</div>
                <div class="helpLink"><a href="https://help.overdrive.com/en-us/1322.htm" target="_blank">${html("macOsAudiobookSupression.learnMore")}</a><div>
            </div>`;
        }

        let titleSpan = `<span class='title'>${this.title.get('title')}</span>`;
        let loansRemaining = this.accountLimits.loansRemaining;

        var youCanBorrowText = '';
        if (loansRemaining > 0) {
            if (this.loan.isMagazine){
                youCanBorrowText = text('accountLoans.magazinesDontCountAgainstCheckout', {loans: loansRemaining});
            } else {
                youCanBorrowText = text('accountLoans.youCanBorrowMoreTitles', {loans: loansRemaining});
            }
        } else {
            youCanBorrowText = text('accountLoans.youCanBorrowNoMoreTitles');
        }

        return `
        <div class="content">
            <div class="row">
                <div class="small-5 columns">${this.cover.$el.html()}</div>
                <div class="small-7 columns metadata-column">
                    <div class="borrowed-until">
                        <div>${this.loan.useFirstPlayText ? text('borrowSuccessModal.loanedUntilFirstPlay', {date: this.loan.expires, title: titleSpan, hours: this.loan.constraints.watchExpirationHours}) :
                        this.isRenewal ? text('renewal.titleNowExpires', {title: titleSpan, expirationDate: this.loan.expires}) :
                        text('borrowSuccessModal.loanedUntil', {date: this.loan.expires, title: titleSpan})}</div>
                        ${this.isRenewal ? '' : `<div class='loans-remaining'>${ youCanBorrowText }</div>`}
                    </div>
                    ${this.loan.bundledContent.length > 0 ? this.renderBundledContent() : ''}
                    <div class="buttons show-for-medium-up">
                        ${ this.isRenewal && !!this.formatLock ?
                            kindleOnly ?
                                `<div class="newDueDate kindleSteps bold">${html('renewal.kindleRenewalInstructions.header')}</div>
                                <ol>
                                    <li class="kindleSteps"><a href='https://www.amazon.com/mn/dcw/myx.html#/home/content/booksAll/dateDsc/' target='_blank'>${html('renewal.kindleRenewalInstructions.returnLinkText')}</a></li>
                                    <li class="kindleSteps">${html('renewal.kindleRenewalInstructions.sendBook')}</li>
                                </ol>` :
                            `<div class="newDueDate bold">${html('renewal.downloadAgainText')}</div>` : ''
                        }
                        ${buttonStack}
                    </div>
                </div>

            </div>

            <div class="buttons full-modal-width show-for-small-only">
                ${ this.isRenewal && !!this.formatLock ?
                    kindleOnly ?
                        `<div class="newDueDate kindleSteps bold">${html('renewal.kindleRenewalInstructions.header')}</div>
                        <ol>
                            <li class="kindleSteps"><a href='https://www.amazon.com/mn/dcw/myx.html#/home/content/booksAll/dateDsc/' target='_blank'>${html('renewal.kindleRenewalInstructions.returnLinkText')}</a></li>
                            <li class="kindleSteps">${html('renewal.kindleRenewalInstructions.sendBook')}</li>
                        </ol>` :
                    `<div class="newDueDate bold">${html('renewal.downloadAgainText')}</div>` : ''
                }
                ${buttonStack}
            </div>
        </div>`;
    }

    getFirstButton() {
        // get whatever element goes in the first position inside the buttons container.  In some cases not actually a button.
        let content = '';
        if (this.loan.isFormatLockedIn){
            if (this.loan.otherFormats && this.loan.otherFormats[0].id === 'ebook-epub-adobe'){
                content = this.renderKindleButton();
            }
            else {
                content = this.renderDownloadButton();
            }
        }
        else if (this.loan.isEbook){
            if (this.loan.hasKindleFormat){
                content = this.renderKindleButton();
            }
            else if (this.loan.showNoKindleMessage){
                content = `<div class='no-kindle-warning'>${text('accountLoans.kindleFulfillment.noneAvailable')}</div>`;
            }
            else if (this.loan.showNonKindleButtonAboveDivider) {
                content = this.renderDownloadButton();
            }
        }
        else if (!this.loan.isMagazine) {
            if ((this.loan.otherFormats.length === 1 || (this.loan.otherFormats.length === 1 && window.OverDrive.inApp)) && !this.suppressAudiobookButton) {
                content = this.renderDownloadButton();
            }
            else if (this.loan.otherFormats.length > 1) {
                content = this.renderDownloadDropdown();
            }
        }
        return content;
    }

    renderButtonDivider(){
        // If we're showing the divider usually there are two fulfillment options being presented.  The exception is the case
        // where the first slot is filled by the "kindle not available" message.
        return `<div class="button-divider-container">
                    <div class="button-divider"></div>
                    ${!this.loan.showNoKindleMessage ? `
                    <span class="divider-text u-allCaps">
                        ${ html('or')}
                    </span>` : ''}
                </div>`;
    }


    renderKindleButton() {
        return `<a target="_blank"  href="${ url(window.routes.mediaDownload, {format: this.loan.kindleFormat.id, mediaId: this.loan.id})}"
                    class="button radius kindleFulfillmentButton" data-download tabindex="0" role="button"
                    data-format-id="${this.loan.kindleFormat.id}" data-media-id="${this.loan.id}"
                    data-format-name="${ html(`formats.${this.loan.kindleFormat.id}`)}">
                    <span> ${text('kindleFulfillment.readNow', { Kindle: `<i class="icon-kindle-logo" aria-label="${html('kindleFulfillment.kindle')}"></i>` })}</span>
                </a>
                <div class='kindle-read-on'>
                    <span>${text('accountLoans.kindleFulfillment.kindleReadOn')}</span>
                    <span style="display:inline-block">
                        <i class='icon-android'></i>
                        <i class='icon-apple'></i>
                        <i class='icon-windows'></i>
                    </span>
                </div>
                ${this.loan.showKindleTroubleAccordian ? this.renderKindleTroubleAccordion() : ''}
                `;
    }

    renderKindleTroubleAccordion(){

        let embeddedButton = '';
        if (this.loan.hasOverdriveFormat){
            embeddedButton = this.renderODReadButton();
        }

        return `<ul class="accordion kindle-trouble-container" data-accordion>
                    <li class="accordion-navigation" >
                        <a class="accordion-title" href="#havingTroublePanel${this.loan.id}">
                            <div class="row">
                                <div class='small-10 columns title-text'>${text('accountLoans.havingTrouble') }</div>
                                <div class='small-2 columns down-arrow-container'>
                                    <i class="icon-down-arrow" aria-hidden="true"></i>
                                </div>
                            </div>
                        </a>
                        <div id="havingTroublePanel${this.loan.id}" class="content">
                            ${embeddedButton}
                            ${this.renderKindleReportLink()}
                        </div>
                    </li>
                </ul>`;
    }

    renderKindleReportLink(){

        return `<div class="report-kindle-problem">
                    <button class="link-button kindle-report-trouble-button">
                        ${text('kindleFulfillment.reportKindleTrouble')}
                    </button>
                </div>`;
    }

    renderDownloadButton() {
        let formatId = this.loan.nonKindleFormats[0].id;
        return `<a target="_blank"
                    class="button loan-button-nonkindle radius primary" tabindex="0" role="button"
                    data-format-id="${formatId}" data-media-id="${ this.loan.id }"
                    data-format-name="${ html(`formats.${formatId}`) }">
                    <b>${formatId === 'ebook-media-do' ? html('readNow') : this.isRenewal && !!this.formatLock ? html('renewal.downloadAgain') : html('accountLoans.download') }</b><br/>
                    <span class="dl-text">${ html(`formats.${formatId}`) }</span>
                </a>`;
    }

    renderODReadButton() {
        let btnSubText = '';
        let btnActionName = '';

        if (this.loan.isEbook || this.loan.isMagazine) {
            btnActionName = text('readNow');
        }
        else if (this.loan.isVideo) {
            btnActionName = window.OverDrive.inApp ? text('addToBookshelf') : text('watchNow');
        }
        else if (this.loan.isAudiobook) {
            btnActionName = text('listenNow');
        }

        if (this.loan.hasReadalong) {
            btnSubText = `<br /><span class="dl-text">${html('narratedModal.heading')}</span>`;
        }

        return `<a ${this.loan.overDriveFormat.id === 'video-streaming' ? 'data-artificial-lock' : ''}
                href= "${ url(window.routes.mediaDownload, { format: this.loan.overDriveFormat.id, mediaId: this.loan.id })}"
                target = "_blank"
                class="button secondary radius od-format-button"
                role = "button"
                data-format-id="${ this.loan.overDriveFormat.id}"
                data-media-id="${ this.loan.id}" > <b>${btnActionName}</b>${btnSubText}
            </a>`;
    }

    renderDownloadDropdown(){

        let options = '';

        this.loan.nonKindleFormats.forEach((format) => {
            options = `${options}
                        <li role="listitem">
                            <a data-artificial-lock tabindex="-1" data-format="${ html(`formats.${format.id}`)}" data-format-id="${format.id}"
                            data-media-id="${ this.loan.id }" aria-label="${html('accountLoans.downloadAs', {format: html(`formats.${format.id}`)})}"
                            ${this.loan.otherFormats[0].id === 'ebook-kindle' ? 'target="_blank"' : ''}
                            class="format"
                            href="${ url(window.routes.mediaDownload, {format: format.id, mediaId: this.loan.id}) }">${ html(`formats.${format.id}`) }</a>
                        </li>`;
        });

        let content = `<button role="button" data-dropdown="formats-${this.loan.id}m"
                                aria-controls="formats-${this.loan.id}" aria-expanded="false" id="download-dropdown"
                                class="button dropdown radius download-dropdown"><b>${ html('accountLoans.download') }</b><br /></button>
                        <ul id="formats-${this.loan.id}m" data-dropdown-content class="f-dropdown download-dropdown-formats" aria-hidden="true" role="list" aria-haspopup="true">
                            ${options}
                        </ul >`;
        return content;
    }

    renderBundledContent()  {
        let bundledButtons = '';
        let restrictedBundle = [];
        this.loan.bundledContent.forEach((subcontent) => {
            let format = subcontent.otherFormats[0];
            let label = '';
            switch (format.id) {
                case 'ebook-overdrive':
                case 'magazine-overdrive':
                    label = html('readNow');
                    break;
                case 'audiobook-overdrive':
                    label = html('listenNow');
                    break;
                case 'video-streaming':
                    label = html('watchNow');
                    break;
                default:
                    label = `${html(`formats.${format.id}`)}<span> ${html('accountLoans.download') }</span>`;
            }
            if (this.isRestricted(format)) {
                restrictedBundle.push(format);
            }
            else if (subcontent.id) {
                bundledButtons += `<li class="Loans-bundleListItem"><a class="Loans-bundledButton button primary radius" data-media-id="${ subcontent.id }" data-format-id="${ format.id || subcontent.overDriveFormat.id }">
                               ${ subcontent.type ? `<i class="icon-${ subcontent.type.id } Loans-bundledFormatIcon"></i>` : '' }
                               ${label}</a></li>`;
            }
            // Thunder isn't passing us the bundled content ID's yet, so we have to use a "Go to loans" button for now
            else {
                bundledButtons = `<li class="Loans-bundleListItem"><a href="/account/loans" class="Loans-bundledButton button primary radius u-allCaps">${text('goToLoans')}</a></li>`;
            }
        });

        return `<a class="Loans-bundleIconLink" data-dropdown="bundleDrop-${ this.loan.id }" aria-controls="bundleDrop-${ this.loan.id }" aria-expanded="false" aria-label="${ html('accountLoans.bundledLabel') }">
                    <i class="icon-attachment Loans-bundledIcon" aria-hidden="true"></i>
                </a>
                <ul id="bundleDrop-${ this.loan.id }" class="f-dropdown Loans-bundledContentList" data-dropdown-content aria-hidden="true" tabindex="-1">
                    <li class="Loans-bundledLabel">${ html('accountLoans.bundledLabel') }</li>
                    ${ bundledButtons }
                    ${ restrictedBundle.length > 0 ? `<li class="Loans-bundleListItem">${this.renderRestrictedFormatWarning(restrictedBundle)}</li>` : ''}
                </ul>
        `;
    }

    renderRestrictedFormatWarning(formats) {
        let pdfLearnMore = '';
        let formatNames = [];
        formats.forEach((format) => {
            // If one of the formats is pdf, add support page link
            if (format.id === 'ebook-pdf-adobe' || format.id === 'ebook-pdf-open') {
                pdfLearnMore = `<span><a href=${window.supportUrl(window.OverDrive._locale, window.OverDrive.supportArticles.ODAppNoPDFEbook)}" target='_blank' class='Loans-learnMoreLink'>${window.text('narratedModal.learnMore')}</a></span>`;
            }
            formatNames.push(format.name);
        });
        let formatsText = formatNames.join(' | ');
        return `<div class="text-center no-download">
                    <span>${formatsText}</span>
                    <strong>${window.text('accountLoans.unsupportedFormat', {formats: formats.length}) + pdfLearnMore }</strong>
                </div>`;
    }

    remove() {
        this._views.forEach((view) => view.remove());
        super.remove();
    }

    filterRestrictedFormats() {
        this.loan.restrictedFormats = [];
        if (this.formatLock) {
            this.loan.otherFormats = this.loan.otherFormats.filter((format) => format.id === this.formatLock);
        }
        this.loan.otherFormats = this.loan.otherFormats.filter((format) => {
            let isRestricted = this.isRestricted(format);
            if (isRestricted) {
                this.loan.restrictedFormats.push(format);
            }
            return !isRestricted;
        });
    }

    isRestricted(format) {
        let device = window.detectshun.browser();
        let isChromebook = !!window.navigator.userAgent.match(/CrOS/);
        let isWindows = window.navigator.platform.match(/Win/) && !device.bowser.windowsphone;
        let inApp = window.OverDrive.inApp;
        let isMac = window.navigator.userAgent.match(/Mac/) && !device.ios;

        switch (format.id) {
            case 'ebook-pdf-adobe' :
                return (device.ios || device.android || device.bowser.windowsphone ||
                device.bowser.blackberry || isChromebook || (isWindows && inApp));
            case 'ebook-epub-adobe' :
                return isChromebook && !inApp;
            case 'ebook-pdf-open' :
                return (((device.ios || device.android || isWindows || isChromebook) && inApp) ||
                device.bowser.windowsphone || device.bowser.blackberry);
            case 'audiobook-mp3' :
                return (isChromebook && !inApp)
                    || (isMac && (this.title.get("formats").length === 1 || (inApp && this.title.get("formats").length === 2))  && this.featureManager.isEnabled('noAudiobooksForMacOS') && (!this.featureManager.isEnabled('reenableMp3DownloadMacOSPreCatalina') || !window.OverDrive.isPreCatalinaMac));
            default :
                return false;
        }
    }
}
